import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

// 오늘(KST) 영업일 판정 — 휴무일(공휴일·콘솔 등록·주말) + 당일 업무 종료시간(조기종료 반영)
export interface BusinessDayResponse {
    date: string; // YYYY-MM-DD
    server_time: string; // YYYY-MM-DD HH:MM (KST)
    is_holiday: boolean;
    reason: "weekend" | "public" | "manual" | null;
    holiday_name: string | null; // 휴무일 명칭, 조기종료일에도 조기종료 명칭 전달
    day_end_time: string | null; // HH:MM, 휴무일이면 null
    customer_cutoff: string | null;
    effective_cutoff: string | null;
    is_open: boolean;
}

export const useGetBusinessDay = (
    options?: Partial<UseQueryOptions<BusinessDayResponse, Error>>,
): UseQueryResult<BusinessDayResponse, Error> => {
    return useQuery({
        queryKey: ["useGetBusinessDay"],
        queryFn: async () => {
            const response = await axiosInstance.get(enum_api_uri.business_day);
            return response.data.data;
        },
        retry: false,
        refetchOnWindowFocus: false,
        ...options,
    });
};
